/**
 * @description Application region enumeration.
 */
export enum Branding {
  RIA = 'RIA',
  Walmart = 'Walmart',
  MirandaEnvios = 'MirandaEnvios',
  Viva = 'Viva',
}


// WEBPACK FOOTER //
// ./src/environment/branding.ts